export default __webpack_public_path__ + "static/media/car.cfc73e12.svg";